<template>
  <div class="-map">
    <div class="-thumbnail-wrapper">
      <div class="-thumbnail" @click="previewAsset">
        <wt-asset-overlay
          :date="publicationDate"
          :dateFull="publicationDateFull"
          :is-asset-restricted="isAssetRestricted"
          :restrictions-text="assetRestrictions"
        >
          <span
            slot="append-right"
            class="wticon wticon-instagram-location"
            v-tooltip="icoTooltip"
          ></span>
        </wt-asset-overlay>
        <a href="#" v-if="!imageError">
          <div v-if="loading" class="-placeholder">
            <span class="wticon wticon-picture-sun"></span>
          </div>
          <img
            :src="mixinSrc(src)"
            @error="onImageError"
            @load="loading = false"
          />
        </a>
        <div v-else class="-placeholder -error">
          <span class="wticon wticon-picture-sun"></span>
        </div>
        <slot name="checkmark"></slot>
      </div>
      <footer :title="footerTitle">{{ footerTitle }}</footer>
    </div>
  </div>
</template>

<script>
import AssetMixins from 'components/assets/mixins/AssetMixins.vue';
import AssetOverlay from 'components/assets/mixins/AssetOverlay.vue';
import Vue from 'vue';

export default Vue.extend({
  mixins: [AssetMixins],
  components: { 'wt-asset-overlay': AssetOverlay },

  computed: {
    icoTooltip() {
      return {
        animation: false,
        trigger: 'hover focus',
        container: '.wt2-asset-gallery .-scroll-container',
        placement: 'bottom auto',
        viewport: {
          selector: '.wt2-asset-gallery .-scroll-container',
          padding: 2,
        },
        delay: { show: 250, hide: 0 },
        wrapperClass: 'tooltip-lightbox-wrapper',
        title: 'Map',
      };
    },
    src: function () {
      return (
        (this.asset && this.asset.metadata && this.asset.metadata.url) || null
      );
    },
    icons() {
      return [
        { iconClass: 'wticon-picture2', location: 'left' },
        { iconClass: 'wticon-licensed-media2', location: 'right' },
      ];
    },
    footerTitle() {
      return this.asset.metadata.caption || this.asset.metadata.title;
    },
  },
});
</script>
